<template>
  <section class="cms-client-rules-icon" :style="positionStyle" @click="clickHandle">
    <img :src="picHost+rulesImg" >
  </section>
</template>

<script>
import DocContent from './DocContent'
import { Sniff } from '@/utils/q_sniff'
export default {
  components: {
    DocContent
  },
  props: {
    rulesImg: {
      type: String,
      default: function() {
        return ''
      }
    },
    rulePlacement: {
      type: String,
      default: 'right'
    },
    isTujiaHarmony: {
      type: Boolean,
      default: false
    },
    tujiaHarmonyStatusBarHeight: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getTop() {
      // const { hastitle } = this.$route.query
      // const HEADER_HEIGHT = 46 + Sniff.statusBarH// 去哪儿标题栏高度
      // let rulesTop = 12
      // // eslint-disable-next-line
      // if (hastitle == 2) {
      //   return rulesTop
      // }
      // // eslint-disable-next-line
      // if (hastitle == 1) {
      //   rulesTop += HEADER_HEIGHT
      //   return rulesTop
      // }
      // // 除了hybird内会默认展示标题栏
      // if (this.platform === 6) {
      //   rulesTop += HEADER_HEIGHT
      //   return rulesTop
      // }
      // return rulesTop
      const { isTujiaAppEnv } = this.platformEnv
      let rulesTop = 12
      if (isTujiaAppEnv) {
        rulesTop += 40
        return rulesTop
      } else {
        return rulesTop
      }
    },
    positionStyle() {
      if (['Q20220709101555'].indexOf(this.$route.query.id) > -1) {
        const scale = window.screen.width / 375
        return `left: ${23 * scale}px; top: ${444 * scale}px; height: ${23 * scale}px`
      }
      const { isTujiaAppEnv } = this.platformEnv
      let rulesTop = 12
      if (Sniff.isHarmonyWithoutAdr) {
        rulesTop = Sniff.immersiveOffset + 52
      } else if (isTujiaAppEnv) {
        rulesTop = this.isTujiaHarmony ? this.tujiaHarmonyStatusBarHeight + 52 : 52
      }
      return this.rulePlacement === 'left' ? `top: ${rulesTop}px` : `top: ${rulesTop}px;right: 0px`
    }
  },
  methods: {
    clickHandle() {
      this.$emit('action', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.cms-client-rules-icon {
  position: absolute;
  height: 40px;
  z-index: 0;
  img {
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    height: 100%;
  }
}
</style>
